import React, { Component } from 'react';
import connect from "react-redux/es/connect/connect";
import moment from 'moment';
import numeral from 'numeral';
import {List, Map} from "immutable";

// Components
import Select from '../../components/common/virtualized-select';
import VirtualizedTable from "../../components/common/virtualized-table";
import ChartComponent from "../../components/common/chart-component";

// Actions
import {getYears, cleanYears} from "../../actions/years";
import {getPurchasesStats, cleanStats} from "../../actions/stats";

// Numeral configuration
import 'numeral/locales/es-es';
numeral.locale('es-es');
numeral.defaultFormat('0,0.00 $');

moment.locale('es');

class PurchasesPage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            selectedYear: moment().year()
        };
    }
    componentDidMount() {
        this.props.getYears();
        this.props.getPurchasesStats({year: this.state.selectedYear});
    }
    componentDidUpdate(prevProps, prevState) {
        if (this.state.selectedYear !== prevState.selectedYear) {
            this.props.getPurchasesStats({year: this.state.selectedYear});
        }
    }
    componentWillUnmount() {
        this.props.cleanStats();
        this.props.cleanYears();
    }

    onChangeYear = (year) => {
        this.setState({
            selectedYear: year
        });
    };

    render() {
        const yearOptions = this.props.years || List([Map({ year: moment().year })]);

        // Billing Purchases Chart
        const chartData = this.props.stats.get('chartData') || List([]);
        const chartConfig = {
            graph: {
                id: 'salesChart',
                type: 'mixed',
                numXAxis: 1,
                numYAxis: 2,
                hover: {
                    mode: 'index',
                    intersect: false
                },
                legend: {
                    show: false
                },
                tooltip: {
                    show: true,
                    mode: 'index'
                },
                datalabels: {
                    show: false
                }
            },
            data: {
                dimension: {
                    field: 'month',
                    label: 'fecha',
                    dataType: 'date',
                    format:'MM',
                    formatLabel: 'MMM'
                },
                metrics: [{
                    field: 'aggregated',
                    label: 'Acumulado',
                    dataType: 'number',
                    type: 'line',
                    color: '#1c84c6',
                    yAxis: '2'
                }, {
                    field: 'invoiced',
                    label: 'Facturado',
                    dataType: 'number',
                    type: 'bar',
                    color: '#23c6c8',
                    yAxis: '1'
                }]
            },
            axis: {
                xAxis: {
                    id: 'x',
                    position: 'bottom',
                    scaleType: 'linear',
                    axisLabel: {
                        show: false
                    },
                    ticks: {
                        show: true,
                        direction: 'horizontal'
                    },
                    gridLines: {
                        show: false
                    }
                },
                yAxis: {
                    sideA: [{
                        id: '1',
                        scaleType: 'linear',
                        axisLabel: {
                            show: true,
                            label: 'Facturación'
                        },
                        ticks: {
                            show: true
                        },
                        gridLines: {
                            show: true,
                            custom: true,
                            lineDash: [3, 5]
                        }
                    }],
                    sideB: [{
                        id: '2',
                        scaleType: 'linear',
                        axisLabel: {
                            show: true,
                            label: 'Acumulado'
                        },
                        ticks: {
                            show: true
                        },
                        gridLines: {
                            show: false
                        }
                    }]
                }
            }
        };

        // Customers Purchases Table
        let tableSettings = {
            sortable: false,
            filterable: false,
            defaultSortFields: [],
            defaultSortDirections: ['asc'],
            height: 164,
            rowHeight: 40,
            strippedRows: false
        };
        let tableData = this.props.stats.get('suppliersStats') || List([]);
        let tableColumns = {
            supplier_code: {
                title: 'Código',
                columnType: 'text',
                dataField: 'supplier_code',
                width: 50,
                style: {},
                sortable: false,
                filterable: false
            },
            fiscal_name: {
                title: "Nombre fiscal",
                columnType: 'text',
                dataField: 'fiscal_name',
                width: 200,
                style: {},
                sortable: false,
                filterable: false
            },
            invoices: {
                title: "# Facturas",
                columnType: 'text',
                dataField: 'invoices',
                width: 75,
                style: { textAlign: 'right' },
                sortable: false,
                filterable: false
            },
            total_invoiced: {
                title: "Importe facturas",
                columnType: 'function',
                dataField: 'total_invoiced',
                width: 100,
                style: { textAlign: 'right' },
                sortable: false,
                filterable: false,
                nodeContent: (total_invoiced) => {
                    return numeral(total_invoiced).format();
                }
            },
            total_receipted: {
                title: "Importe Albaranes",
                columnType: 'function',
                dataField: 'total_receipted',
                width: 130,
                style: { textAlign: 'right' },
                sortable: false,
                filterable: false,
                nodeContent: (total_receipted) => {
                    return numeral(total_receipted).format();
                }
            },
            total_ordered: {
                title: "Importe pedidos",
                columnType: 'function',
                dataField: 'total_ordered',
                width: 140,
                style: { textAlign: 'right' },
                sortable: false,
                filterable: false,
                nodeContent: (total_ordered) => {
                    return numeral(total_ordered).format();
                }
            }
        };

        return (
            <div id="page-wrapper" className="gray-bg">
                <div className="row wrapper border-bottom white-bg page-heading">
                    <div className="col d-flex align-items-center" style={{ height: 35 }} >
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item active">
                                <strong>Compras</strong>
                            </li>
                        </ol>
                    </div>
                    <div className="col d-flex align-items-center justify-content-end">
                        <div className="title-action">
                            <Select
                                style={{ width: 75 }}
                                options={yearOptions.toJS()}
                                value={this.state.selectedYear}
                                labelKey='year'
                                valueKey='year'
                                matchProp='year'
                                multi={false}
                                searchable={true}
                                clearable={false}
                                onChange={(selectedValue) => { if (selectedValue) this.onChangeYear(selectedValue.year) }}
                            />
                        </div>
                    </div>
                </div>
                <div className="wrapper wrapper-content">
                    <div className="row">
                        <div className="col">
                            <div className="ibox">
                                <div className="ibox-title">
                                    <h5>Facturación</h5>
                                </div>
                                <div className="ibox-content">
                                    <div className="row">
                                        <div className="col-3">
                                            <h1 className="font-bold">{ this.props.stats.get('numInvoices') }</h1>
                                            <h3 className="text-muted">Facturas</h3>
                                            <h1 className="font-bold">{ numeral(this.props.stats.get('totalInvoiced')).format() }</h1>
                                            <h3 className="text-muted">Importe facturas</h3>
                                        </div>
                                        <div className="col-9" style={{ paddingTop: 10 }} >
                                            <ChartComponent
                                                type={ chartConfig.graph.type }
                                                data={ chartData }
                                                config={ chartConfig }
                                                // height={150}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-6">
                            <div className="ibox">
                                <div className="ibox-title">
                                    <h5>Albaranes</h5>
                                </div>
                                <div className="ibox-content">
                                    <div className="row">
                                        <div className="col">
                                            <h1 className="font-bold">{ this.props.stats.get('numReceipts') }</h1>
                                            <h3 className="text-muted">Albaranes</h3>
                                        </div>
                                        <div className="col">
                                            <h1 className="font-bold">{ numeral(this.props.stats.get('totalReceipted')).format() }</h1>
                                            <h3 className="text-muted">Importe albaranes</h3>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-6">
                            <div className="ibox">
                                <div className="ibox-title">
                                    <h5>Pedidos</h5>
                                </div>
                                <div className="ibox-content">
                                    <div className="row">
                                        <div className="col">
                                            <h1 className="font-bold">{ this.props.stats.get('numOrders') }</h1>
                                            <h3 className="text-muted">Pedidos</h3>
                                        </div>
                                        <div className="col">
                                            <h1 className="font-bold">{ numeral(this.props.stats.get('totalOrdered')).format() }</h1>
                                            <h3 className="text-muted">Importe total pedidos</h3>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col">
                            <div className="ibox">
                                <div className="ibox-title">
                                    <h5>Proveedores</h5>
                                </div>
                                <div className="ibox-content">
                                    <div className="row stats-zone" style={{ margin: '10px 0' }} >
                                        <div className="col-auto">
                                            <span className="label">{ this.props.stats.get('suppliersStats') && this.props.stats.get('suppliersStats').size }</span>
                                            <span>Proveedores</span>
                                        </div>
                                        <div className="col-auto">
                                            <span className="label label-primary">{ this.props.stats.get('numActive') }</span>
                                            <span>Activos</span>
                                        </div>
                                        <div className="col-auto">
                                            <span className="label label-danger">{ this.props.stats.get('numInactive') }</span>
                                            <span>Inactivos</span>
                                        </div>
                                    </div>
                                    <VirtualizedTable
                                        tableSettings={tableSettings}
                                        tableColumns={tableColumns}
                                        tableData={tableData}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {

    // Reducers
    const yearsReducer = state.years;
    const statsReducer = state.stats;

    // Years
    let years = yearsReducer.get('payload') || List([]);

    if (!(years instanceof List)) {
        years = List([])
    }

    // Stats
    let stats = statsReducer.get('payload') || Map({});

    if (!(stats instanceof Map)) {
        stats = Map({})
    }

    return {
        years,
        stats
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getYears: () => dispatch(getYears()),
        getPurchasesStats: (year) => dispatch(getPurchasesStats(year)),
        cleanYears: () => dispatch(cleanYears()),
        cleanStats: () => dispatch(cleanStats())
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(PurchasesPage);



// WEBPACK FOOTER //
// ./src/containers/purchases/PurchasesPage.js